export default __webpack_public_path__ + "static/media/logo.60c3a5de.png";